/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ExpenseOperator {
    IS = 'IS',
    IS_NOT = 'IS_NOT',
    IS_NONE_OF = 'IS_NONE_OF',
    IS_ANY_OF = 'IS_ANY_OF',
}
